import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Header.css';
import logoImage from '../assets/logo-removebg-preview.png';

const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      setIsScrolled(scrollTop > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header className={`header ${isScrolled ? 'header-scrolled' : ''}`}>
      <div className="header-container">
        {/* Logo */}
        <Link to="/" className="logo">
          <img src={logoImage} alt="Rajni Indian Cuisine Logo" className="logo-image" />
        </Link>

        {/* Navigation Menu */}
        <nav className={`nav-menu ${isMobileMenuOpen ? 'nav-menu-open' : ''}`}>
          <ul className="nav-list">
            <li>
              <Link 
                to="/" 
                className={`nav-link ${location.pathname === '/' ? 'active' : ''}`} 
                onClick={() => setIsMobileMenuOpen(false)}
              >
                Home
              </Link>
            </li>
            <li>
              <a 
                href="/#about" 
                className="nav-link" 
                onClick={() => setIsMobileMenuOpen(false)}
              >
                About Us
              </a>
            </li>
            <li>
              <a 
                href="/#gallery" 
                className="nav-link" 
                onClick={() => setIsMobileMenuOpen(false)}
              >
                Gallery
              </a>
            </li>
            <li>
              <Link 
                to="/menu" 
                className={`nav-link ${location.pathname === '/menu' ? 'active' : ''}`} 
                onClick={() => setIsMobileMenuOpen(false)}
              >
                Menu
              </Link>
            </li>
            <li>
              <a 
                href="/#contact" 
                className="nav-link" 
                onClick={() => setIsMobileMenuOpen(false)}
              >
                Contact Us
              </a>
            </li>
          </ul>
        </nav>

        {/* Reservation Button */}
        <div className="reservation-section">
          <button className="reservation-btn">
            Order Online
          </button>
        </div>

        {/* Mobile Menu Toggle */}
        <button 
          className={`mobile-menu-toggle ${isMobileMenuOpen ? 'mobile-menu-open' : ''}`}
          onClick={toggleMobileMenu}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
    </header>
  );
};

export default Header;
